define('services/myservices/pay.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('payService', ['$q', '$filter', 'ngDialog', 'OpenApp', 'auiDialog', 'HuaweiTrade', '$state', 'opearteShaService', 'myServicesAddSer', 'OpenUp', 'modBussService', 'auiAgreementHelper', 'UserInfo', 'tenantsService', 'invoiceService',
        function ($q, $filter, ngDialog, OpenApp, auiDialog, HuaweiTrade, $state, opearteShaService, myServicesAddSer, OpenUp, modBussService, auiAgreementHelper, UserInfo, tenantsService, invoiceService) {
            var regexp = mainCons.servicesConstant.regexp;
            var devres = {};
            var isShowedPayDia = false;

            // 指纹示例
            function getFingerPrintExam(prodType) {
                //免安装应用-rpk sha256指纹比较特别
                return (prodType == "19-1" || prodType == "23" || prodType == "28"  || prodType == "42") ?
                    '59d55fa3eefdac5425ada6a8ee005f777c3cbe01c8b4a7028cc635ea3532f78d'
                    : '8B:3C:0D:0C:32:90:7B:7B:5E:F8:C3:9C:EF:D0:A4:0D:15:4B:DE:C4:C4:A7:25:A6:0B:A7:2A:7B:32:6C:70:DA';
            }

            function getFingerPrintInfo(appInfo, targetObj) {
                targetObj.oauthCertFingerprint = '';
                targetObj.oauthCertFingerprint1 = '';
                targetObj.oauthCertFingerprint2 = '';
                targetObj.oauthCertFingerprint3 = '';
                targetObj.oauthCertFingerprint4 = '';
                if (appInfo && appInfo.appAttrs) {
                    var attrs = angular.fromJson(appInfo.appAttrs);
                    var prodType = appInfo.prodType;
                    if (AUI.BaseJSUtil.existy(attrs.oauthCertFingerprint)) {
                        //免安装应用-rpk sha256指纹比较特别
                        targetObj.oauthCertFingerprint = (prodType == 28 || prodType == "42" ||prodType == 23 || prodType == 19 && appInfo.freeInstallType == 1 ) ? attrs.oauthCertFingerprint : AUI.BaseJSUtil.sha2show(attrs.oauthCertFingerprint);
                    }
                    if (prodType != "19" && prodType != "23"&& prodType != "28" &&  prodType != "42") {
                        if (AUI.BaseJSUtil.existy(attrs.certFingerprintExtra)) {
                            if (AUI.BaseJSUtil.existy(attrs.certFingerprintExtra) && typeof attrs.certFingerprintExtra == 'string') {
                                var certFingerprintExtraTempDel = attrs.certFingerprintExtra.split(';');
                                if (certFingerprintExtraTempDel.length > 0) {
                                    for (var h = 0; h < certFingerprintExtraTempDel.length; h++) {
                                        targetObj['oauthCertFingerprint' + (h + 1)] = AUI.BaseJSUtil.sha2show(certFingerprintExtraTempDel[h]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            function testRedirectUri(callbackUrl) {
                ngDialog.open({
                    template: 'pages/myservices/pay/pay.callbackurltest.html',
                    // replace: true,
                    className: '',
                    controller: ['$scope', function ($scope1) {
                        var Model1 = $scope1.Model1 = {
                            regexp: mainCons.servicesConstant.regexp,
                            merSignType: {
                                name: 'RSA256',
                                value: 'RSA256'
                            },
                            signTypes: [{name: 'RSA256', value: 'RSA256'}, {name: 'RSA', value: 'RSA'}],
                            selectedPayType: {
                                value: -1
                            },
                            payType: [
                                {name: '统一帐号支付', value: 0}, {name: '充值卡支付', value: 1}, {
                                    name: '游戏点卡',
                                    value: 2
                                }, {name: '银行卡支付', value: 3}, {name: '支付宝支付', value: 4},
                                {name: '短代支付', value: 6}, {name: '非银行卡', value: 7}, {
                                    name: '非银行卡余额',
                                    value: 8
                                }, {name: '组合支付', value: 9}
                            ],
                            payAmount: '',
                            payOrderID: '',
                            callBackUrl: callbackUrl,
                            testDoc:sysParamCfg.payTestCallbackUrlDoc
                        };

                        $scope1.checkParams = checkParams;
                        $scope1.sendTest = sendTest;
                        $scope1.cancel = cancel;

                        function checkParams(str, reg) {
                            if (!AUI.BaseJSUtil.existy(str)) {
                                return true;
                            }
                            return (new RegExp(reg)).test(str);
                        }

                        function sendTest(files, type) {
                            var defer = $q.defer();
                            if (!(Model1.selectedPayType.value != -1 && Model1.payAmount != '' && Model1.payOrderID != ''
                                    && (checkParams(Model1.callBackUrl, Model1.regexp.oauthRedirectUri) || Model1.callBackUrl.indexOf('?') > 0 || Model1.callBackUrl.substring(Model1.callBackUrl.length - 1) == '\\')
                                    && Model1.callBackUrl != '')) {
                                return null;
                            }

                            var params = {
                                params: {
                                    content: "amount=" + Model1.payAmount + "&merSignType=" + Model1.merSignType.value + "&orderId=" + Model1.payOrderID + "&paytype=" + Model1.selectedPayType.value + "&url=" + Model1.callBackUrl,
                                    signtype: 'HMAC',
                                    keytype: 'trade-hmacsha256'
                                }
                            };
                            HuaweiTrade.sign(params).then(function (data) {
                                var res = angular.fromJson(data);
                                if (res.returnCode == '0') {
                                    var setParams = {
                                        itemName: 'notifyTest',
                                        params: {
                                            paytype: Model1.selectedPayType.value,
                                            amount: Model1.payAmount,
                                            orderId: Model1.payOrderID,
                                            url: Model1.callBackUrl,
                                            signType: 'HMAC',
                                            sign: res.sign,
                                            merSignType: Model1.merSignType.value
                                        }
                                    };
                                    HuaweiTrade.set(setParams).then(function (data) {
                                        var setRes = angular.fromJson(data);
                                        if (setRes.returnCode == 0) {
                                            auiDialog.success("测试成功。");
                                            defer.resolve();
                                        } else {
                                            auiDialog.fail("失败",$filter('auiMapWithDefault')(setRes.returnCode, mainCons.mapWithDefaultConstant.testPayErrorFilter, "测试失败。"));
                                            defer.reject();
                                        }
                                    }).catch(function (data) {
                                        defer.reject();
                                    });
                                } else {
                                    auiDialog.fail("测试失败。");
                                    defer.reject();
                                }
                            }).catch(function (data) {
                                defer.reject();
                            });
                            return defer.promise;
                        }

                        function cancel() {
                            ngDialog.close();
                        }

                    }]
                });
            }

            /**
             * 判断商户权限
             */
            function hasMerchantAuth() {
                var defer = $q.defer();
                auiAgreementHelper.queryAgreements([auiAgreementHelper.judgeAgreementByServiceItem("tenants")]).then(function (res) {
                    if (res && res.signInfoList && res.signInfoList.length > 0 &&
                        (res.signInfoList[0].signStatus === 1 || (res.signInfoList[0].signStatus === 2 && res.signInfoList[0].isForcedSign == 'false'))) {
                        tenantsService.isBankVoid().then(function (isMerchant) {
                            defer.resolve(isMerchant);
                        });
                    } else {
                        defer.resolve(false);
                    }
                }).catch(function () {
                    defer.resolve(false);
                });
                return defer.promise;
            }

            function checkPayService(cb) {
                UserInfo.promise().then(function (userInfo) {
                    if (userInfo.verifyRealState && userInfo.verifyRealState == 2) {
                        auiAgreementHelper.checkAgreement('tenants', function () {
                            $state.go('home', {}, {reload: true});
                        }, userInfo).then(function (result) {
                            if (result.signed) {
                                // 商户协议OK
                                if (result.signNow) {
                                    // 刚刚签署，直接跳到商户设置页面
                                    $state.go('mysetting.modBussnessInfo', {}, {reload: true});
                                } else {
                                    // 早就签过了
                                    tenantsService.isBankVoid().then(function (isMerchant) {
                                        if (isMerchant) {
                                            // 有srmcode，直接检查联运协议
                                            angular.isFunction(cb) && cb();
                                        } else {
                                            // 无srmcode，弹窗提示，回到卡片页
                                            auiDialog.warn("您的商户服务还未开通或者处于审核中，感谢您的耐心等待。", function () {
                                                $state.go('home');
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    } else {
                        auiDialog.warn("您的实名认证信息正在审核中，感谢您的耐心等待。", function () {
                            $state.go('home');
                        });
                    }
                });
            }

            function submit(Model) {
                var defer = $q.defer();
                if (!Model.selected || !Model.product || !Model.product.appInfo) {
                    defer.reject();
                } else {
                    modeUserInfo(Model).then(function () {// 设置回调地址
                        myServicesAddSer.updateOauthFingerPrint(Model).then(function () {// 修改指纹
                            myServicesAddSer.updatePackageNameOrWebUrl(Model).then(function () {// 修改包名
                                addPayService(Model).then(function () {// 添加服务
                                    $state.go('rollout.submitSuccess', {
                                        serviceItem: Model.serviceItem,
                                        product: Model.product
                                    }, {reload: true});
                                }).catch(function () {
                                    defer.reject();
                                });
                            }).catch(function () {
                                defer.reject();
                            });
                        }).catch(function () {
                            defer.reject();
                        });
                    }).catch(function (data) {
                        defer.reject();
                    });
                }
                return defer.promise;
            }

            // 添加服务
            function modeUserInfo(Model) {
                var appInfo = Model.product.appInfo;
                var defer = $q.defer();
                // 获得签名
                var signParams = {
                    params: {
                        content: "applicationID=" + appInfo.appID + (AUI.BaseJSUtil.existy(Model.selected.callbackUrl) ? "&url=" + Model.selected.callbackUrl : ""),
                        signtype: "HMAC",
                        keytype: 'trade-hmacsha256'
                    }
                };
                HuaweiTrade.sign(signParams).then(function (signData) {
                    var data1 = angular.fromJson(signData);
                    if (data1 && data1.returnCode === '0') {
                        // 生成应用的公钥、私钥信息
                        var modparams = {
                            params: {
                                applicationID: appInfo.appID,
                                url: Model.selected.callbackUrl || "",
                                signType: "HMAC",
                                sign: data1.sign
                            }
                        };
                        HuaweiTrade.modUserInfo(modparams).then(function (modData) {
                            var data2 = angular.fromJson(modData);
                            if (data2 && data2.returnCode === 0) {
                                defer.resolve();
                            } else {
                                defer.reject();
                                auiDialog.fail("修改回调地址失败。");
                            }
                        }).catch(function (data) {
                            defer.reject();
                            auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                        });
                    } else {
                        defer.reject();
                        auiDialog.fail("生成应用的公钥失败。");
                    }
                }).catch(function (data) {
                    defer.reject();
                    auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                });
                return defer.promise;
            }


            function addPayService(Model) {
                var defer = $q.defer();
                var appInfo = Model.product.appInfo;
                if (Model.product.serviceSingle && Model.product.serviceSingle.srvSerialNo) {
                    defer.resolve();
                } else {
                    var addServiceParams = {
                        request: {
                            prodID: appInfo.appID,
                            prodType: appInfo.prodType,
                            serviceItem: 8
                        }
                    };
                    OpenApp.addService(addServiceParams).then(function (addData) {
                        if (addData && addData.srvSerialNo) {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    }).catch(function (data) {
                        defer.reject(data);
                    });
                }
                return defer.promise;
            }



            function getPayDeveloperKey(developerKeyParam) {
                var defer = $q.defer();
                var contentTemp = "";

                // 获取公钥私钥
                var serialNo = Date.parse(new Date()) + parseInt(100000000 * Math.random(), 10);

                if (developerKeyParam.enableHuaweiKey){
                    contentTemp += "&enableHuaweiKey=" + developerKeyParam.enableHuaweiKey;
                }

                if (developerKeyParam.keyIndex){
                    contentTemp += "&keyIndex=" + developerKeyParam.keyIndex;
                }

                if (developerKeyParam.keyType){
                    contentTemp += "&keyType=" + developerKeyParam.keyType;
                }
                if (developerKeyParam.merchantpub){
                    contentTemp += "&merchantpub=" + developerKeyParam.merchantpub;
                }

                contentTemp += "&serialNo=" + serialNo;

                contentTemp += "&userID=" + UserInfo.get().id;

                // 去掉首字母的&
                contentTemp = contentTemp.substr(1);

                var signParams = {
                    params: {
                        content: contentTemp,
                        signtype: 'HMAC',
                        keytype: 'trade-hmacsha256'
                    }
                };
                HuaweiTrade.sign(signParams).then(function (data) {
                    var res = angular.fromJson(data);
                    if (res.returnCode === '0') {
                        var paramsTemp = {};
                        paramsTemp.serialNo = serialNo;
                        paramsTemp.sign = res.sign;
                        paramsTemp.signType = "HMAC";
                        paramsTemp.userID  =  UserInfo.get().id;

                        if (developerKeyParam.keyType){
                            paramsTemp.keyType = developerKeyParam.keyType;
                        }
                        if (developerKeyParam.keyIndex){
                            paramsTemp.keyIndex = developerKeyParam.keyIndex;
                        }
                        if (developerKeyParam.merchantpub){
                            paramsTemp.merchantpub = developerKeyParam.merchantpub;
                        }
                        if (developerKeyParam.enableHuaweiKey){
                            paramsTemp.enableHuaweiKey = developerKeyParam.enableHuaweiKey;
                        }

                        var devsignPrams = {
                            params: paramsTemp
                        };
                        HuaweiTrade.getDevelopSign(devsignPrams).then(function (data) {
                            devres = angular.fromJson(data);
                            defer.resolve(devres);
                            if(data.returnCode == 3){
                                auiDialog.fail("您上传的密钥不合法，请重新输入");
                            }
                        }).catch(function (e) {
                            defer.reject(e);
                        });
                    } else {
                        auiDialog.fail("获取签名失败");
                    }
                })
                // }
                return defer.promise;
            }

            function checkSecretKeys() {
                var defer = $q.defer();
                hasMerchantAuth().then(function (hasAuth) {
                    if (hasAuth) {
                        // 判断是否是新商户
                        var params = {keyType: 2};
                        getPayDeveloperKey(params).then(function (resp) {
                            if (resp.returnCode == 0 && !resp.developPubKey) {
                                showGetKeyMode(resp);
                            }
                        });
                    }
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            function getPaymentInfo() {
                var defer = $q.defer();
                hasMerchantAuth().then(function (hasAuth) {
                    if (hasAuth) {
                        // 判断是否是新商户
                        var params = {keyType: 2};
                        getPayDeveloperKey(params).then(function (resp) {
                            if (resp.returnCode != 3) {
                                showGetKeyMode(resp);
                            } else {
                                auiDialog.fail("获取公钥私钥失败");
                            }
                        });
                    } else {
                        auiDialog.warn("您的商户服务还未开通或者处于审核中，无法获取支付信息，如果有疑问请联系客服。");
                    }
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //选择自定义或者系统生成密钥弹窗
            function showGetKeyMode(parameter) {
                var dialog = ngDialog.open({
                    template: 'pages/myservices/pay/pay.get-payment-info.html',
                    className: '',
                    controller: ['$scope', 'payService', 'UserInfo', function ($scope, payService, UserInfo) {
                        UserInfo.promise().then(function (userInfo) {
                            $scope.CPID = userInfo.id;
                        });
                        if(parameter.developKey){
                            $scope.developKey = parameter.developKey;
                            $scope.developKeyLength = parameter.developKey.length * 8;
                            if(parameter.developKey == "MerchantPrivateKey"){
                                $scope.showSystemKey = false;
                            }else{
                                $scope.showSystemKey = true;
                            }
                        }
                        if(parameter.developPubKey){
                            $scope.developPubKey = parameter.developPubKey;
                            $scope.developPubKeyLength = parameter.developPubKey.length * 8;
                        }
                        if(parameter.huaweiPubKey){
                            $scope.huaweiPubKey = parameter.huaweiPubKey;
                            $scope.huaweiPubKeyLength = parameter.huaweiPubKey.length * 8;
                        }
                        if(parameter.developNewKeys){
                            $scope.developNewKey = parameter.developNewKeys[0].priKey;
                            $scope.developNewKeyLength = parameter.developNewKeys[0].priKey.length * 8;
                            $scope.developNewPubKey = parameter.developNewKeys[0].pubKey;
                            $scope.developNewPubKeyLength = parameter.developNewKeys[0].pubKey.length * 8;
                        }

                        var isClicked = true;
                        $scope.generationValue = 1;
                        $scope.enableHuaweiKey = 0;
                        $scope.generationCustom = false;
                        $scope.merchantErrorMsg = "";
                        $scope.payInfo ={};
                        $scope.cancel = function () {
                            dialog.close();
                        };
                        $scope.checkedGeneration = function (value) {
                            $scope.generationValue = value;
                            $scope.generationCustom = (value == 2 ? true:false);
                        };
                        $scope.checkHuaweiKey = function (value) {
                            value = $scope.enableHuaweiKey;
                            $scope.enableHuaweiKey = (value == 0 ? 1:0);
                        };
                        $scope.createKeyMode = function () {
                            var defer = $q.defer();
                            if($scope.generationValue == 1){
                                var paramKey = {keyType: 3,enableHuaweiKey:$scope.enableHuaweiKey};
                                isNotCreateKeyCode(paramKey,$scope,defer);
                            }else{
                                //密钥长度大于3072位
                                if($scope.payInfo.merchantpub && $scope.payInfo.merchantpub.length >= 384){
                                    $scope.merchantErrorMsg = "";
                                    var paramKey2 = {keyType: 3,merchantpub:$scope.payInfo.merchantpub,enableHuaweiKey:$scope.enableHuaweiKey};
                                    isNotCreateKeyCode(paramKey2,$scope,defer);
                                }else if(!$scope.payInfo.merchantpub || $scope.payInfo.merchantpub.length == 0){
                                    $scope.merchantErrorMsg = "请输入您要上传的密钥";
                                    defer.reject();
                                }else{
                                    $scope.merchantErrorMsg = "您输入的密钥长度小于3072位";
                                    defer.reject();
                                }
                            }
                            return defer.promise;
                        };
                        $scope.createSecretKey = function () {
                            var paramKey = {keyType: 3};

                            isClicked = true;
                            auiDialog.confirm('请确认是否需要生成密钥', function () {
                                if(isClicked){
                                    isClicked = false;
                                    getPayDeveloperKey(paramKey).then(function (data) {
                                        if(data && data.returnCode == 0){
                                            dialog.close();
                                            getPaymentInfo();
                                        }
                                    });
                                }


                            }, function () {
                                dialog.close();
                            });
                        };
                        $scope.upLoadSecretKey = function () {
                            //密钥长度大于3072位
                            if($scope.payInfo.secondMerchantpub && $scope.payInfo.secondMerchantpub.length >= 384){
                                $scope.merchantErrorMsg = "";
                                var paramKey = {keyType: 3,merchantpub:$scope.payInfo.secondMerchantpub};

                                isClicked = true;
                                auiDialog.confirm('请确认是否需要生成密钥?', function () {
                                    if(isClicked){
                                        isClicked = false;
                                        getPayDeveloperKey(paramKey).then(function (data) {
                                            if(data.returnCode == 0){
                                                dialog.close();
                                                getPaymentInfo();
                                            }
                                        });
                                    }


                                }, function () {
                                    dialog.close();
                                });
                            }else if(!$scope.payInfo.secondMerchantpub || $scope.payInfo.secondMerchantpub.length == 0){
                                $scope.merchantErrorMsg = "请输入您要上传的密钥";
                                return false;
                            }else{
                                $scope.merchantErrorMsg = "您输入的密钥长度小于3072位";
                                return false;
                            }
                        };
                    }]
                });
            }

            function isNotCreateKeyCode(paramKey,scope,defer) {
               var isClicked = true;
                auiDialog.confirm('请确认是否需要生成密钥', function () {
                    if(isClicked){
                        isClicked = false;
                        getPayDeveloperKey(paramKey).then(function (data) {
                            if(data.returnCode == 0){
                                defer.reject();
                                if(data.developKey){
                                    scope.developKey = data.developKey;
                                    scope.developKeyLength = data.developKey.length * 8;
                                    if(scope.developKey == "MerchantPrivateKey"){
                                        scope.showSystemKey = false;
                                    }else{
                                        scope.showSystemKey = true;
                                    }
                                }
                                if(data.developPubKey){
                                    scope.developPubKey = data.developPubKey;
                                    scope.developPubKeyLength = data.developPubKey.length * 8;
                                }
                                if(data.huaweiPubKey){
                                    scope.huaweiPubKey = data.huaweiPubKey;
                                    scope.huaweiPubKeyLength = data.huaweiPubKey.length * 8;
                                }
                                if(data.developNewKeys){
                                    scope.developNewKey = data.developNewKeys[0].priKey;
                                    scope.developNewKeyLength =data.developNewKeys[0].priKey.length * 8;
                                    scope.developNewPubKey = data.developNewKeys[0].pubKey;
                                    scope.developNewPubKeyLength =data.developNewKeys[0].pubKey.length * 8;
                                }
                            }
                        }).catch(function () {
                            defer.reject();
                        });
                    }else{
                        defer.reject();
                    }

                },function () {
                    defer.reject();
                });
            }


            //是否可以支付，支付审核通过后并且有PRMCode,已经废弃，不适用
            // 目前判断税务&发票填写完成才可以
            function isPayable() {
                var defer = $q.defer();
                getPayStatus().then(function (rs) {
                    defer.resolve('2' == rs);
                });
                return defer.promise;
            }

            //产品要求两种状态，考虑向前兼容，实现上3状态：0：未填写，1：已填写，未完成，2：已完成
            function getPayStatus() {
                var defer = $q.defer();
                UserInfo.getUserInfo().then(function (res){
                    if (res.userType != 1) {
                    invoiceService.getInvoiceInfo(function (data) {
                        if (data && data.userTaxInfo && data.userTaxInfo.registerAddress && data.userTaxInfo.taxNum
                            && data.receipt && data.receipt.location && data.receipt.bankName
                            && data.receipt.contactName && data.receipt.cellPhone && data.receipt.registerPhone && data.receipt.accountEmail) {
                            //不依赖用户的payCertifyStatus
                            defer.resolve('2');
                        } else if (data && data.resultCode === 0) {
                            defer.resolve('0');
                        }
                    });
                    } else {
                        invoiceService.getInvoiceInfo(function (data) {
                            if (data.receipt && data.receipt.contactName && data.receipt.cellPhone && data.receipt.accountEmail) {
                                //不依赖用户的payCertifyStatus
                                defer.resolve('2');
                            } else if (data && data.resultCode === 0) {
                                defer.resolve('0');
                            }
                        });
                    }
                })
                    return defer.promise;
            }

            //付费状态解耦，审核中对用户来说已经算通过，后期有问题，再提醒用户，责任由用户负责
            //0 未填写，1：已提交(提交就算付费服务状态开通)
            function getPayStatusByUser(user) {
                var rs = user && user.payCertifyStatus;
                return rs;
            }

            //给激励金使用
            function setPayDialogIsShow() {
                isShowedPayDia = true;
            }

            function getPayDialogIsShow() {
                return isShowedPayDia;
            }



            return {
                getFingerPrintExam: getFingerPrintExam,
                getFingerPrintInfo: getFingerPrintInfo,
                testRedirectUri: testRedirectUri,
                hasMerchantAuth: hasMerchantAuth,
                getPayDeveloperKey: getPayDeveloperKey,
                getPaymentInfo: getPaymentInfo,
                checkPayService: checkPayService,
                checkSecretKeys:checkSecretKeys,
                submit: submit,
                isPayable: isPayable,
                getPayStatusByUser: getPayStatusByUser,
                setPayDialogIsShow: setPayDialogIsShow,
                getPayDialogIsShow: getPayDialogIsShow
            }

        }]);
});


